/**
 * API エラー基底クラス
 * @param message - エラーメッセージ
 * @param statusCode - HTTPステータスコード
 * @param errorCode - アプリケーション固有のエラーコード
 */
export class ApiError extends Error {
  statusCode: number;
  errorCode?: string;

  constructor(message: string, statusCode: number, errorCode?: string) {
    super(message);
    this.name = 'ApiError';
    this.statusCode = statusCode;
    this.errorCode = errorCode;
  }
}

/**
 * 認証エラー（401）
 * @param message - エラーメッセージ（デフォルト: '認証が必要です'）
 */
export class AuthenticationError extends ApiError {
  constructor(message = '認証が必要です') {
    super(message, 401, 'AUTHENTICATION_REQUIRED');
    this.name = 'AuthenticationError';
  }
}

/**
 * 権限エラー（403）
 * @param message - エラーメッセージ（デフォルト: 'アクセス権限がありません'）
 */
export class AuthorizationError extends ApiError {
  constructor(message = 'アクセス権限がありません') {
    super(message, 403, 'ACCESS_DENIED');
    this.name = 'AuthorizationError';
  }
}

/**
 * ネットワークエラー
 * @param message - エラーメッセージ（デフォルト: 'ネットワークエラーが発生しました'）
 */
export class NetworkError extends ApiError {
  constructor(message = 'ネットワークエラーが発生しました') {
    super(message, 0, 'NETWORK_ERROR');
    this.name = 'NetworkError';
  }
}

/**
 * サーバーエラー（500）
 * @param message - エラーメッセージ（デフォルト: 'サーバーエラーが発生しました'）
 */
export class ServerError extends ApiError {
  constructor(message = 'サーバーエラーが発生しました') {
    super(message, 500, 'SERVER_ERROR');
    this.name = 'ServerError';
  }
}
